import {observer} from 'mobx-react';
import React, {useEffect, useState} from 'react';
import styles from './ButtonHoc.module.scss';

interface ButtonHocProps {
    className?: string;
    disabled?: boolean;
    onClick?: () => void;
    onClickAsync?: boolean;
    label?: string | React.ReactNode;
    ariaLabel?: string | 'unlabeled';
    debounce?: number;
    children?: React.ReactNode;
    loading?: boolean;
}

const ButtonHoc: React.FC<ButtonHocProps> = (props) => {
    const {
        onClick = () => undefined,
        onClickAsync = false,
        debounce: debounceTime,
        children,
        disabled,
        ariaLabel,
        className = '',
    } = props;

    const [disabledAsync, setDisabledAsync] = useState<boolean>(false);

    const [disabledDebounce, setDisabledDebounce] = useState<boolean>(false);
    const [timeOutId, setTimeOutId] = useState<NodeJS.Timeout>();

    useEffect(() => () => clearTimeout(timeOutId), [timeOutId]);

    const debounce = () => {
        if (!!debounceTime) {
            setDisabledDebounce(true);
            setTimeOutId(setTimeout(() => setDisabledDebounce(false), debounceTime));
        }
    };

    const loading = props.loading || disabledAsync || disabledDebounce;

    return (
        <button
            aria-label={ariaLabel}
            className={[styles.buttonHoc, className].join(' ')}
            disabled={disabled || disabledAsync || disabledDebounce}
            onClick={async (e) => {
                e.stopPropagation();
                debounce();
                if (onClickAsync) {
                    setDisabledAsync(true);
                    await onClick();
                    setDisabledAsync(false);
                } else {
                    onClick();
                }
            }}
        >
            <div style={loading ? {height: 0, overflow: 'hidden'} : {}}>{children}</div>
            {loading && <div>...</div>}
        </button>
    );
};

export default observer(ButtonHoc);
